import { render, staticRenderFns } from "./VIPGrow.vue?vue&type=template&id=4dda8dc4&scoped=true&"
import script from "./VIPGrow.vue?vue&type=script&lang=js&"
export * from "./VIPGrow.vue?vue&type=script&lang=js&"
import style0 from "./VIPGrow.vue?vue&type=style&index=0&id=4dda8dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda8dc4",
  null
  
)

export default component.exports